import { render, staticRenderFns } from "./takePhotos.vue?vue&type=template&id=77d01a0e&scoped=true&"
import script from "./takePhotos.vue?vue&type=script&lang=js&"
export * from "./takePhotos.vue?vue&type=script&lang=js&"
import style0 from "./takePhotos.vue?vue&type=style&index=0&id=77d01a0e&prod&lang=less&scoped=true&"
import style1 from "./takePhotos.vue?vue&type=style&index=1&id=77d01a0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d01a0e",
  null
  
)

export default component.exports